<template lang="pug">
//- .d-flex.flex-row.flex(v-if="marqueeList.length >= 1")
//-   marquee.flex.mr-1.flex-grow-1.font-weight-bold(behavior="scroll" direction="left" scrollamount="5") {{ marqueeList[0]['msg_' + language] }}
.marquee(v-if="marqueeList.length >= 1" ref="marqueeRoot" :style="marqueeRootStyle")
  span.font-weight-bold(ref="marqueeText") {{ marqueeList[0]['msg_' + language] }}
</template>

<script>
const MARQUEE_PX_PER_SEC = 55;
const MARQUEE_MIN_SEC = 12;
const MARQUEE_MAX_SEC = 180;

export default {
  data() {
    return {
      marqueeList: [],
      marqueeDurationSec: 15
    };
  },
  computed: {
    language() {
      if(this.$store.getters.language == "zh") {
        return "cn"
      } else {
        return this.$store.getters.language
      }
    },
    marqueeRootStyle() {
      return { "--marquee-duration": `${this.marqueeDurationSec}s` };
    }
  },
  watch: {
    language() {
      this.$nextTick(() => this.updateMarqueeDuration());
    }
  },
  mounted() {
    this.getMarqueeList();
  },
  beforeDestroy() {
    if (this._marqueeResizeObserver) {
      this._marqueeResizeObserver.disconnect();
      this._marqueeResizeObserver = null;
    }
  },
  methods: {
    getMarqueeList() {
      this.marqueeList = [];
      this.$store.dispatch("message/getMarqueeList").then(res => {
        this.marqueeList = res.value;
        this.$nextTick(() => {
          if (!this.marqueeList.length) {
            this.teardownMarqueeObserver();
            return;
          }
          this.afterMarqueeData();
        });
      });
    },
    teardownMarqueeObserver() {
      if (this._marqueeResizeObserver) {
        this._marqueeResizeObserver.disconnect();
        this._marqueeResizeObserver = null;
      }
    },
    afterMarqueeData() {
      this.updateMarqueeDuration();
      this.teardownMarqueeObserver();
      const root = this.$refs.marqueeRoot;
      if (!root || typeof ResizeObserver === "undefined") return;
      this._marqueeResizeObserver = new ResizeObserver(() => {
        this.updateMarqueeDuration();
      });
      this._marqueeResizeObserver.observe(root);
    },
    updateMarqueeDuration() {
      this.$nextTick(() => {
        const el = this.$refs.marqueeText;
        if (!el) return;
        const w = el.offsetWidth;
        const sec = Math.min(
          MARQUEE_MAX_SEC,
          Math.max(MARQUEE_MIN_SEC, w / MARQUEE_PX_PER_SEC)
        );
        this.marqueeDurationSec = Math.round(sec * 10) / 10;
      });
    }
  }
};
</script>
